
import './ColumnSource.scss';
import TaskSource from '../TaskSource/TaskSource';


const ColumnSource = (props) => {
  

// SET TaskList COMPONENT

  const TaskList = (props) => {

    return (
      <div className='taskList' >
        
        {props.tasks.map((task, index) => (
          <TaskSource key={task.id} task={task} index={index} 
              
          />
          ))}

        
      </div>
    )
};

    return (
      <div className="Column">
        <div className='container'>
        

              <TaskList tasks={props.tasks} 
              styleAnswer={props.styleAnswer}
              isSelected={props.isSelected}
              />

        </div>
         
  
      </div>
    );




  }
  
  export default ColumnSource;